import { render, staticRenderFns } from "./ProfileVerifyData.vue?vue&type=template&id=0687e268"
import script from "./ProfileVerifyData.vue?vue&type=script&lang=js"
export * from "./ProfileVerifyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports